import clsx from 'clsx';
import { SpinnerIcon } from '@/public/assets/svg';
import { SpinnerProps } from './types';
const Spinner = ({
  className
}: SpinnerProps) => {
  return <SpinnerIcon className={clsx('inline animate-spin fill-primary-600 text-primary-200', className)} data-sentry-element="SpinnerIcon" data-sentry-component="Spinner" data-sentry-source-file="index.tsx" />;
};
export default Spinner;